// Module
var code = "<h3>Entities associated to Zenflow account</h3> <div id=\"entitiesGrid\"></div> ";
// Exports
export default code;